import cn from '@/lib/cs';
import React from 'react';

const AudioDescriptionIcon = ({
	className,
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.953 18.643c.1.648-1.41.216-1.913.216-1.51-1.405 1.108-2.702-3.02-2.81C2.315 18.21 2.82 19.507 0 18.75l1.51-7.026c.302-1.621-.503-4.864 1.309-5.404 1.006.216 2.718-.973 3.221.216.302 4.107 1.309 8.106 1.913 12.106zm-4.53-4.972h1.41l-.202-.649a.801.801 0 01-.1-.432v-.865l-.303-1.08c-.201-.433-.302-.757-.201-1.19v-.108l-.604 4.324zM15 10.644c0 6.161-.403 7.674-6.544 7.242-.302-3.459-.604-7.242 0-10.7 2.517-.217 6.443-.217 6.544 3.458zm-2.315-.54c-.202-.865-1.007-1.405-1.813-1.081-.604 2.162.403 4.431 0 6.701 2.618 1.405 1.41-3.89 1.813-5.62z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M22.258 5l.968 1.96.193 1.57.387 1.568.194 1.569v1.568l-.194 1.569-.29 1.569-.484 1.47-.677 1.863-.968.294-.484-.098-.096-.098.193-.686.677-1.765.387-1.373.484-1.372.097-1.47v-1.373l-.29-1.373-.387-1.47-.194-1.373L21 5.589 20.71 5l1.548.098V5zm-2.903.196v.686l.677 1.765.774 1.47v1.667l.29 1.667v1.569l-.386 1.666-.581 1.47-.677 1.668-.871.196-.387-.785.677-1.568.387-1.373.29-1.47v-1.471l.194-1.47-.387-1.471-.484-1.373-.58-.98-.485-1.177 1.549-.686zm-2.903 1.47l.677 1.57.774 1.274v1.47l.29 1.373v1.47l-.387 1.471-.58 1.275-.774 1.372-.871.196-.484-.392v-.098l.193-.392.678-1.275.484-1.372.193-1.47v-3.04l-.774-1.274-.58-1.57L15 6.864l1.452-.196z"
			clipRule="evenodd"
		/>
	</svg>
);

export default AudioDescriptionIcon;
